import { PurchaseActionOption } from "common";
import React from "react";
import { Purchase } from "types";
import { Printer } from "@/components/Common/Printer";
import { CreatePurchaseNoteModal } from "@/components/PurchaseModification/CreatePurchaseNoteModal";
import { PastBookingWarningModal } from "@/components/PurchasesMenu/PastBookingWarningModal";
import { PurchaseReceipt } from "@/components/Receipt/PurchaseReceipt";

interface CommonActionModalsState {
    purchase: Purchase;
    selectedOption: PurchaseActionOption | null;
    warningModalOpen: boolean;
    remainingAction: PurchaseActionOption | null;
    shouldRefetchPurchase: boolean;
    isLoading: boolean;
    shouldPrintStart: boolean;
    PostCheckInWarningModal: React.ComponentType<{ onClose?: () => void }>;
}

interface CommonActionModalsActions {
    onModalClose: () => void;
    refreshPurchaseRow: () => void;
    setSelectedOption: (option: PurchaseActionOption | null) => void;
    setWarningModalOpen: (open: boolean) => void;
    setShouldPrintStart: (start: boolean) => void;
}

interface CommonActionModalsProps {
    menuState: CommonActionModalsState;
    menuActions: CommonActionModalsActions;
    onClose?: () => void;
}

export const CommonActionModals = ({ menuState, menuActions, onClose }: CommonActionModalsProps) => {
    const {
        purchase,
        selectedOption,
        warningModalOpen,
        remainingAction,
        shouldRefetchPurchase,
        isLoading,
        shouldPrintStart,
        PostCheckInWarningModal,
    } = menuState;
    const { onModalClose, refreshPurchaseRow, setSelectedOption, setWarningModalOpen, setShouldPrintStart } =
        menuActions;

    return (
        <>
            <CreatePurchaseNoteModal
                purchase={purchase}
                isOpen={selectedOption === PurchaseActionOption.ADD_PURCHASE_NOTE}
                onClose={onModalClose}
                onContinue={refreshPurchaseRow}
            />

            <PastBookingWarningModal
                isOpen={warningModalOpen}
                onClose={() => {
                    setWarningModalOpen(false);
                    onClose?.();
                }}
                onContinue={() => {
                    setWarningModalOpen(false);
                    setSelectedOption(remainingAction);
                    if (remainingAction === PurchaseActionOption.PRINT_RECEIPT) {
                        setShouldPrintStart(true);
                    }
                }}
            />

            <PostCheckInWarningModal {...(onClose ? { onClose } : {})} />

            {shouldRefetchPurchase && !isLoading && shouldPrintStart ? (
                <Printer
                    enablePaperCut={false}
                    enableDrawerEject={false}
                    shouldStart={shouldPrintStart}
                    onFinish={() => {
                        setShouldPrintStart(false);
                        onClose?.();
                    }}
                >
                    <PurchaseReceipt purchase={purchase} />
                </Printer>
            ) : null}
        </>
    );
};
